module.exports = __webpack_public_path__ + "img/aws.c08efe18.png";